import React, { useEffect, useRef, useState } from "react";
import { Sparkles } from "lucide-react";
import { Button } from "../../../ui/button";
import { money, testKey } from "./format";

export const FounderInsights = ({ days }) => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const controller = useRef(null);
  useEffect(() => {
    setSummary(null); setError(""); setLoading(false);
    return () => controller.current?.abort();
  }, [days]);
  const load = async () => {
    controller.current?.abort();
    const abort = new AbortController(); controller.current = abort;
    setLoading(true); setError("");
    try {
      const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/founder-summary?days=${days}`, { credentials: "include", signal: abort.signal });
      if (!r.ok) throw new Error("Summary is unavailable.");
      const result = await r.json(); if (!abort.signal.aborted) setSummary(result.summary);
    } catch (e) { if (!abort.signal.aborted) setError(e.message); }
    finally { if (!abort.signal.aborted) setLoading(false); }
  };
  return <div className="border-t border-[var(--hairline)] pt-5 space-y-4" data-testid="founder-insights">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <h2 className="font-serif text-base md:text-lg">Founder insights</h2>
      <Button size="sm" variant="outline" disabled={loading} onClick={load} data-testid="founder-insights-generate"><Sparkles size={14} />{loading ? "Preparing…" : "Generate AI summary"}</Button>
    </div>
    <p className="text-xs text-[var(--muted)]" data-testid="founder-insights-cost-notice">On-demand AI · cached for one hour · generation may incur a charge.</p>
    {error && <p role="alert" className="text-sm text-[var(--crimson)]" data-testid="founder-insights-error">{error}</p>}
    {summary && <div className="space-y-4">
      <p className="font-serif text-lg" data-testid="founder-headline">{summary.headline}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        {[["Top insight", summary.top_insight], ["Concern", summary.concern], ["Efficiency", summary.llm_efficiency], ["Recommendation", summary.recommendation]].map(([label, value]) => value && <div key={label} data-testid={`founder-${testKey(label)}`}><p className="text-xs text-[var(--muted)] mb-1">{label}</p><p className="text-sm">{value}</p></div>)}
      </div>
      {summary.daily_cost_avg_usd != null && <p className="text-xs text-[var(--muted)]" data-testid="founder-cost-projection">Daily average {money(summary.daily_cost_avg_usd)} · Projected monthly {money(summary.projected_monthly_usd)}</p>}
    </div>}
  </div>;
};